import { Link } from 'react-router-dom';

import { Links } from 'links';

import { SnapContributedOffer } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<SnapContributedOffer>[] = [{
  width: 80,
  title: 'ID',
  dataIndex: 'offer.id',
  render: (_, { offer: { order, id } }) => (
    <Link
      to={`${Links.Offers}/${id}`}
      state={{ redirectFrom: `${Links.Offers}${window.location.search}` }}
    >
      {order}
    </Link>
  ),
}, {
  width: 300,
  title: 'Offer name',
  dataIndex: 'offer.name',
}, {
  width: 80,
  title: 'Points',
  dataIndex: 'offer.miles',
  align: 'center',
}, {
  width: 300,
  type: TColumn.type.Ellipsis,
  title: 'Description',
  dataIndex: 'offer.description',
}, {
  width: 100,
  title: 'Points Issued',
  dataIndex: 'milesAmount',
  align: 'center',
}, {
  width: 80,
  type: TColumn.type.FetchImageByID,
  title: 'Image',
  dataIndex: 'offer.imageMetadataId',
}, {
  width: 110,
  type: TColumn.type.Status,
  title: 'Status',
  dataIndex: 'status',
}, {
  width: 120,
  type: TColumn.type.Checkbox,
  title: 'Participation',
  dataIndex: 'offer.isParticipation',
}];
